import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import ReactTable, { ReactTableDefaults } from 'react-table';
import { push } from 'react-router-redux';
import {
  get,
  uniq,
  filter,
  omit,
  maxBy,
} from 'lodash';
import moment from 'moment';
import exportExcel from '../../helpers/exportExcel';
import getLabel from '../../helpers/getLabel';
import Loading from '../Loading';
import BlankState from '../BlankState';
import { PAGE_SIZE } from '../../config';
import Pagination from '../Pagination';
import { schoolsSchoolMarketQuery } from '../../apollo';


class SchoolTableSchoolMarket extends Component {
  state = {
    searchTerm: '',
  }

  exportSchools = () => {
    const tableData = this.selectTable.getResolvedState().sortedData;
    const filteredData = tableData.map(({ _original }) => _original);
    const { enums } = this.props;
    const {
      schoolMarketTypes,
      operatingFrequencies,
      preferredDistributionDays,
      preferredDistributionTimes,
    } = enums;

    const columnData = [
      { header: 'School Name', key: 'name' },
      { header: 'District', key: 'districtName' },
      { header: 'Zip', key: 'zip' },
      { header: 'County', key: 'county' },
      { header: 'State', key: 'state' },
      { header: 'Address 1', key: 'address1' },
      { header: 'Address 2', key: 'address2' },
      { header: 'Level', key: 'type' },
      { header: 'Program Status', key: 'statusSchoolMarket' },
      { header: 'Term', key: 'termFormattedShort' },
      { header: 'Date Submitted', key: 'submittedAtFormatted' },
      { header: 'Application Status', key: 'applicationStatus' },
      { header: 'Certified Verification', key: 'certififedVerification' },
      { header: 'Waitlisted', key: 'waitlisted' },
      { header: 'Waitlisted At', key: 'waitlistedAtFormatted' },
      { header: 'Market Type', key: 'marketType' },
      { header: 'Operataing Frequency', key: 'operatingFrequency' },
      { header: 'Preferred Distribution Day', key: 'preferredDistributionDay' },
      { header: 'Preferred Distribution Time', key: 'preferredDistributionTime' },
      { header: 'Secondary Preferred Distribution Day', key: 'secondaryPreferredDistributionDay' },
      { header: 'Secondary Preferred Distribution Time', key: 'secondaryPreferredDistributionTime' },
      { header: 'Free Lunch', key: 'numFreeLunch' },
      { header: 'Reduced Lunch', key: 'numReducedLunch' },
      { header: 'Total Enrollment', key: 'numTotalEnrollment' },
      { header: 'Participated in program last year', key: 'participatedLastYear' },
      { header: 'Principal Name', key: 'principalName' },
      { header: 'Principal Email', key: 'principalEmail' },
      { header: 'Primary Point of Contact Name', key: 'primaryPointOfContactName' },
      { header: 'Primary Point of Contact Email', key: 'primaryPointOfContactEmail' },
      { header: 'Primary Point of Contact Phone', key: 'primaryPointOfContactPhone' },
    ];

    const rowData = [];

    filteredData.forEach((school) => {
      const principal = school.teamMembersSchoolMarket.find(({ type }) => type === 'PRINCIPAL');
      const primaryPointOfContact = school.teamMembersSchoolMarket.find(({ type }) => type === 'PRIMARY_POINT_OF_CONTACT');
      const schoolData = {
        ...school,
        principalName: get(principal, 'fullName', 'N/A'),
        principalEmail: get(principal, 'email', 'N/A'),
        primaryPointOfContactName: get(primaryPointOfContact, 'fullName', 'N/A'),
        primaryPointOfContactEmail: get(primaryPointOfContact, 'email', 'N/A'),
        primaryPointOfContactPhone: get(primaryPointOfContact, 'phone', 'N/A'),
      };

      if (school.applicationsSchoolMarket.length) {
        school.applicationsSchoolMarket.forEach((application) => {
          const applicationStatus = application.status;
          const participatedLastYear = application.new ? 'No' : 'Yes';
          const marketType = getLabel(schoolMarketTypes.options, application.marketType);
          const operatingFrequency = getLabel(operatingFrequencies.options, application.operatingFrequency);
          const preferredDistributionDay = getLabel(preferredDistributionDays.options, application.preferredDistributionDay);
          const preferredDistributionTime = getLabel(preferredDistributionTimes.options, application.preferredDistributionTime);
          const secondaryPreferredDistributionDay = application.secondaryPreferredDistributionDay ? getLabel(preferredDistributionDays.options, application.secondaryPreferredDistributionDay) : '';
          const secondaryPreferredDistributionTime = application.secondaryPreferredDistributionTime ? getLabel(preferredDistributionTimes.options, application.secondaryPreferredDistributionTime) : '';
          const submittedAtFormatted = application.submittedAt
            ? moment.utc(application.submittedAt).format('M-D-YY')
            : '';
          const waitlisted = application.waitlisted ? 'Yes' : 'No';
          const waitlistedAtFormatted = application.waitlistedAt
            ? moment.utc(application.waitlistedAt).format('M-D-YY')
            : '';

          rowData.push({
            submittedAtFormatted,
            participatedLastYear,
            applicationStatus,
            waitlisted,
            waitlistedAtFormatted,
            marketType,
            operatingFrequency,
            preferredDistributionDay,
            preferredDistributionTime,
            secondaryPreferredDistributionDay,
            secondaryPreferredDistributionTime,
            ...schoolData,
            ...omit(application, [
              'status',
              'waitlisted',
              'waitlistedAt',
              'marketType',
              'operatingFrequency',
              'preferredDistributionDay',
              'preferredDistributionTime',
              'secondaryPreferredDistributionDay',
              'secondaryPreferredDistributionTime',
            ]),
          });
        });
      } else {
        rowData.push({
          ...schoolData,
        });
      }
    });

    exportExcel('schools', columnData, rowData, 'School Market');
  };


  selectFilter = (props, termSchools, options = null) => {
    const { filter: filterObj, onChange, column } = props;

    const uniqOptions = uniq(termSchools.map(school => (
      get(school, `[${column.id}]`)
    )));

    return (
      <select
        className="filter-select w-select"
        onChange={event => onChange(event.target.value)}
        value={filterObj ? filterObj.value : ''}
      >
        <option value="">{column.Header}</option>
        {
          uniqOptions.map(value => (
            <option key={`${value}+${column.id}`} value={value}>{(options && value !== 'N/A') ? getLabel(options, value) : value}</option>
          ))
        }
      </select>
    );
  }

  searchResults(termSchools) {
    const { searchTerm } = this.state;

    return filter(termSchools, ({
      name,
      districtName,
      zip,
      county,
      type,
      statusSchoolMarket,
      primaryPointOfContact,
    }) => {
      const lowerCase = text => text.toLowerCase();
      const regexFunc = fieldValueSearch => new RegExp(searchTerm).test(fieldValueSearch);

      return regexFunc(lowerCase(name))
        || regexFunc(lowerCase(districtName))
        || regexFunc(lowerCase(type))
        || regexFunc(lowerCase(county))
        || regexFunc(zip)
        || regexFunc(lowerCase(statusSchoolMarket))
        || (primaryPointOfContact && regexFunc(lowerCase(primaryPointOfContact.fullName)))
        || (primaryPointOfContact && regexFunc(lowerCase(primaryPointOfContact.email)))
        || (primaryPointOfContact && regexFunc(lowerCase(primaryPointOfContact.phone)));
    });
  }


  render() {
    const { selectedTermId, enums, dispatch } = this.props;

    const {
      schoolTypes,
      programStatuses,
    } = enums;

    return (
      <Query
        query={schoolsSchoolMarketQuery}
        variables={{ termId: selectedTermId }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, data, error }) => {
          if (error) return <BlankState title="Error" subtitle="There was an error loading" />;
          if (!data.schoolsSchoolMarket && loading) return <Loading />;

          const { schoolsSchoolMarket: termSchools } = data;
          const filteredTermSchools = this.searchResults(termSchools);
          const findPrimaryPointOfContact = row => row.teamMembersSchoolMarket && row.teamMembersSchoolMarket.find(({ type }) => type === 'PRIMARY_POINT_OF_CONTACT');

          const columns = [{
            Header: 'School',
            accessor: 'name',
            filterable: false,
          }, {
            Header: 'District',
            accessor: 'districtName',
          }, {
            Header: 'Zip',
            accessor: 'zip',
          }, {
            Header: 'County',
            accessor: 'county',
          }, {
            Header: 'Level',
            accessor: 'type',
            Cell: row => getLabel(schoolTypes.options, row.value),
            Filter: props => this.selectFilter(props, termSchools, schoolTypes.options),
          }, {
            Header: 'Program Status',
            accessor: 'statusSchoolMarket',
            Cell: row => getLabel(programStatuses.options, row.value),
            Filter: props => this.selectFilter(props, termSchools, programStatuses.options),
          }, {
            id: 'fullName',
            Header: 'Contact Name',
            accessor: row => get(findPrimaryPointOfContact(row), 'fullName'),
            filterable: false,
          }, {
            id: 'email',
            Header: 'Contact Email',
            accessor: row => get(findPrimaryPointOfContact(row), 'email'),
            filterable: false,
          }, {
            id: 'phone',
            Header: 'Contact Phone',
            accessor: row => get(findPrimaryPointOfContact(row), 'phone'),
            filterable: false,
          }, {
            id: 'new',
            Header: 'Returning',
            accessor: (d) => {
              const activeApplications = d.applicationsSchoolMarket.filter(({ status }) => status === 'APPROVED');
              const mostRecent = maxBy(activeApplications, o => o.createdAt);
              if (mostRecent) {
                return mostRecent.new ? 'No' : 'Yes';
              }
              return 'N/A';
            },
            Filter: (props) => {
              const { filter: filterObj, onChange, column } = props;
              return (
                <select
                  className="filter-select w-select"
                  onChange={event => onChange(event.target.value)}
                  value={filterObj ? filterObj.value : 'all'}
                >
                  <option value="">{column.Header}</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              );
            },
          }, {
            id: 'archived',
            Header: 'Archived',
            accessor: row => (row.deletedAt ? 'Yes' : 'No'),
            Filter: (props) => {
              const { onChange, column } = props;
              return (
                <select
                  className="filter-select w-select"
                  onChange={event => onChange(event.target.value)}
                >
                  <option value="No">{column.Header}</option>
                  <option value="">Show All</option>
                </select>
              );
            },
          }];

          return (
            <Fragment>
              <div className="date-export admin-schools backpack-buddy">
                <div
                  onClick={this.exportSchools}
                  className="export-btn w-button admin-schools"
                >
                  Export
                </div>
              </div>
              <input
                type="text"
                className="search-bar w-input"
                onChange={evt => (
                  this.setState({ searchTerm: evt.target.value.trim().toLowerCase() })
                )}
                placeholder="Search"
              />
              <ReactTable
                className="schools-table school-market"
                ref={(r) => {
                  this.selectTable = r;
                }}
                data={filteredTermSchools}
                columns={columns}
                loadingText=""
                NoDataComponent={() => <BlankState title="No Results" />}
                minRows={0}
                filterable
                defaultPageSize={PAGE_SIZE}
                PaginationComponent={Pagination}
                defaultFiltered={[{
                  id: 'archived',
                  value: 'No',
                }]}
                defaultSorted={[{
                  id: 'name',
                  desc: false,
                }]}
                getTrGroupProps={(state, rowInfo) => ({
                  className: 'table-row school-row w-clearfix',
                  style: { cursor: 'pointer' },
                  onClick: () => dispatch(push(`/school-market/schools/${rowInfo.original.schoolId}`)),
                })}
                getTdProps={() => ({
                  className: 'table-col schools-cells',
                })}
                getTheadTrProps={() => ({
                  className: 'table-row table-header w-clearfix',
                })}
                getTheadFilterTrProps={() => ({
                  className: 'filters',
                })}
                column={
                  {
                    ...ReactTableDefaults.column,
                    headerClassName: 'table-col schools-header w-inline-block pointer noselect',
                    minWidth: 85,
                    width: '10%',
                    Cell: row => row.value || 'N/A',
                    Filter: props => this.selectFilter(props, termSchools),
                  }
                }
              />
            </Fragment>
          );
        }
        }
      </Query>
    );
  }
}

SchoolTableSchoolMarket.propTypes = {
  selectedTermId: PropTypes.string.isRequired,
  enums: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default SchoolTableSchoolMarket;
